import { cn } from "@/lib/utils";
import { useI18n } from "@/lib/i18n";
import type { BlogCategory } from "@/lib/blog";

interface Props {
  category: BlogCategory;
  className?: string;
}

export function CategoryChip({ category, className }: Props) {
  const { t } = useI18n();
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border border-accent/40 bg-accent/15 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-accent-foreground",
        className,
      )}
    >
      {t(`blog.cat.${category}`)}
    </span>
  );
}
